var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"load-more"},[_c('v-btn',{attrs:{"color":"primary","disabled":_vm.isLoadingTableRows,"loading":_vm.isLoadingTableRows,"outlined":"","large":""},on:{"click":function($event){return _vm.$emit('onLoadMore')}}},[_vm._v(" "+_vm._s(_vm.$t('general.load_more'))+"... ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }